var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import RCModal from 'react-modal';
import { isBrowser } from '@snack-uikit/utils';
import { MODE, SIZE } from '../../constants';
import { ButtonClose, ModalBody, ModalFooter, ModalHeader, OverlayElement, } from '../../helperComponents';
import styles from './styles.module.css';
import { getDataTestAttributes } from './utils';
export function ModalCustom(_a) {
    var { open, onClose, size = SIZE.S, mode = MODE.Regular, children, className } = _a, rest = __rest(_a, ["open", "onClose", "size", "mode", "children", "className"]);
    const handleCloseButtonClick = () => {
        onClose();
    };
    const handleClose = () => {
        if (mode === MODE.Regular) {
            onClose();
        }
    };
    if (!open) {
        return null;
    }
    return (_jsxs(RCModal, { data: Object.assign(Object.assign({}, getDataTestAttributes(rest)), { size }), isOpen: true, onRequestClose: handleClose, appElement: isBrowser() ? document.body : undefined, overlayElement: (_, content) => (_jsx(OverlayElement, { blur: [MODE.Forced, MODE.Aggressive].includes(mode), content: content, onClose: handleClose })), className: cn(styles.modal, className), children: [mode !== MODE.Forced && (_jsx("div", { className: styles.headerElements, children: _jsx(ButtonClose, { onClick: handleCloseButtonClick }) })), children] }));
}
(function (ModalCustom) {
    ModalCustom.Header = ModalHeader;
    ModalCustom.Body = ModalBody;
    ModalCustom.Footer = ModalFooter;
})(ModalCustom || (ModalCustom = {}));
